const SET_CLIENT_LIST = 'SET_CLIENT_LIST';

export default {
  SET_CLIENT_LIST
};